/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/GameModes/GameModeBase',[],function () {
    "use strict";

    var GameModeBase = function () {
        this.initGameModeBase();
    };

    GameModeBase.prototype.initGameModeBase = function () {
        this.WaitForAnimationOnHint = false;
    };

    GameModeBase.prototype.GetAvatarImage = function (model) {
        throw "unsupported";
    };

    GameModeBase.prototype.SetDefaults = function (model) {
        throw "TODO - set up defauls"; // TODO
        /*model.NewGameButtonText = LocalizationManager.GetString("NewGameButton_Title");
        model.HomeButtonText = LocalizationManager.GetString("HomeButton_Title");
        model.ShareButtonText = LocalizationManager.GetString("ShareButton_Title");
        model.UpdateText = null;// LocalizationManager.GetString("Update_Title");
        model.UpdateImageSourcePath = "Assets/ui/game_end/DailyChallenge-banner.png";
        model.ToolTipVisible = Visibility.Collapsed;
        model.Optional1Command = new RelayCommand<object>(OnRedealCurrentGame);
        model.NewGameCommand = new RelayCommand<object>(OnNewGame);
        model.HomeCommand = new RelayCommand<object>(OnHome);
        model.ShareCommand = new RelayCommand<object>(OnShare);
        model.ShowUpdateMessageAction = OnUpdate;
        model.HighlightedButton = 0;*/
        //GetAvatar(model);
    };

    GameModeBase.OnUpdate = function () {
    };

    GameModeBase.OnHome = function (parameter) {
        throw "TODO - navigate to " + parameter; // TODO
        /*if (App.CurrentApp.SolitaireGame.Authority.IsChallenge)
        {
            DailyChallengeService.Default.DailyChallengeNavigation.GoToDailyChallenge();
        }
        else
        {
            App.CurrentApp.Navigate<MainPage>();
        }*/
    };

    GameModeBase.OnNewGame = function (parameter) {
        throw "TODO - start new game"; // TODO
        /*AnalyticsHelper.Current.SendMenuShown(SentientMenuID.GameStart, SentientSubMenuID.Undefined);
        Messenger.Default.Send(new DealMessage(false));*/
    };

    GameModeBase.SetDefaultShareMessage = function (description, message, name) {
        throw "unsupported";
        /*string gameTitle = LocalizationManager.GetLocalizedString("SolitaireCollection_Title/Text");
        description.Append(LocalizationManager.GetString(string.Format("Share_Description_{0}",name)));
        message.Append(LocalizationManager.GetString(string.Format("Share_Message_{0}",name)));
        return gameTitle;*/
    };

    return GameModeBase;

});
